export default __webpack_public_path__ + "static/media/404.a0cb038f.svg";